import { createContext, ReactNode } from 'react';

import { EuiBreadcrumb } from '@elastic/eui';

type TopMenuContextType = {
  breadcrumbs: EuiBreadcrumb[];
  setBreadcrumbs: (items: EuiBreadcrumb[]) => void;
  extraSection: ReactNode | null;
  setExtraSection: (item: ReactNode) => void;
};

export const TopMenuContext = createContext<TopMenuContextType | null>(null);
